import { buildInfo } from 'environments/build-info';

export function applyBuildInfoMarker(): void {
    document.documentElement.dataset['build'] = buildInfo.buildNumber;
}
